import React from 'react';
import { useTranslation } from 'react-i18next';
import type { TicketMessage } from '../types/ticket';

const EVENT_KEY: Record<string, string> = {
  'status:in_progress': 'timelineEvent.statusInProgress',
  'status:resolved': 'timelineEvent.statusResolved',
  'status:resolved:self': 'timelineEvent.statusResolvedSelf',
  'status:reopened': 'timelineEvent.statusReopened',
  'status:closed': 'timelineEvent.statusClosed',
  'status:closed:auto': 'timelineEvent.statusClosedAuto',
};

export default function TicketTimelineEvent({ message }: { message: TicketMessage }) {
  const { t } = useTranslation('tickets');
  const eventType = message.systemEventType ?? '';
  const labelKey = EVENT_KEY[eventType];
  const label = labelKey ? t(labelKey) : (eventType || t('timelineEvent.fallback'));
  return (
    <div style={{ textAlign: 'center', fontSize: 12, color: 'var(--text-muted, #888)', margin: '10px 0' }}>
      ─── {label} · {new Date(message.createdAt).toLocaleString()} ───
    </div>
  );
}
